'use client';

import { useState } from 'react';
import { CollapsibleHeader } from './CollapsibleHeader';
import Checkbox from '@/components/subflow-v3/components/Checkbox/Checkbox';

export interface FilterOption {
  label: string;
  value: string;
}

export interface FilterSectionProps {
  title: string;
  options: FilterOption[];
  selectedValues: string[];
  onSelectionChange: (values: string[]) => void;
  isInitiallyOpen?: boolean;
  allowMultiple?: boolean;
}

export const FilterSection = ({
  title,
  options,
  selectedValues,
  onSelectionChange,
  isInitiallyOpen = false,
  allowMultiple = true,
}: FilterSectionProps) => {
  const [isOpen, setIsOpen] = useState(isInitiallyOpen);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleCheckboxChange = (value: string, checked: boolean) => {
    if (allowMultiple) {
      const newValues = checked
        ? [...selectedValues, value]
        : selectedValues.filter((v) => v !== value);
      onSelectionChange(newValues);
    } else {
      // Single selection mode
      const newValues = checked ? [value] : [];
      onSelectionChange(newValues);
    }
  };

  return (
    <div className="bg-white w-full">
      <CollapsibleHeader
        title={title}
        isOpen={isOpen}
        onToggle={handleToggle}
      />

      {isOpen && (
        <div className="pt-4">
          {/* Options list */}
          <div className="space-y-2">
            {options.map((option) => (
              <Checkbox
                key={option.value}
                id={option.value}
                label={option.label}
                onChange={(value) =>
                  handleCheckboxChange(option.value, value.target.checked)
                }
                value={selectedValues.includes(option.value)}
                isLabelClickable={true}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
